



























import { Vue, Component } from 'vue-property-decorator';
import EditGroupRobotModal from './editGroupRobotModal.vue';
import AddRobotGuideModal from './addRobotGuideModal.vue';
import * as api from '@/api';
@Component({
    components: {
        EditGroupRobotModal,
        AddRobotGuideModal
    }
})
export default class groupRobot extends Vue {
    tableLoading: boolean = false;
    showModal: boolean = false;
    showGuideModal: boolean = false;
    settingList: CommonTypes.mapObject[] = [];
    data: CommonTypes.mapObject = {};
    groupId: number = 0;
    created() {
        this.getDxGroupList();
    }
    async getDxGroupList() {
        this.tableLoading = true;
        try {
            const res = await api.rgApi.getDxGroupListener(this.rgId);
            const { data } = res;
            if (data) {
                this.settingList = data || [];
                this.tableLoading = false;
            }
        } catch (error) {
            this.tableLoading = false;
            console.log(error);
        }
    }
    onSuccess(id, needGuide) {
        this.showModal = false;
        this.getDxGroupList();
        this.groupId = id;
        // 新增配置 or 编辑配置修改了大象群 时，展示引导弹窗
        if (needGuide) this.showGuideModal = true;
    }
    createGroup() {
        this.data = {};
        this.showModal = true;
    }
    async deleteGroup(id) {
        const _this = this;
        this.$mtd
            .confirm({
                title: '是否确认删除',
                width: '433px',
                showCancelButton: true,
                type: 'warning',
                okButtonText: '确认',
                className: 'common-modal',
                okButtonProps: {
                    type: 'danger',
                    class: 'tt-pure-btn'
                },
                cancelButtonProps: {
                    class: 'tt-pure-btn'
                },
                message: '删除后，对应群聊则无法通过大象机器人生成TT，是否确认删除',
                onOk: async () => {
                    try {
                        await api.rgApi.deleteDxGroupListener(id);
                        this.$mtd.message({
                            message: '删除成功',
                            type: 'success'
                        });
                        await _this.getDxGroupList();
                    } catch (e) {
                        console.log(e);
                    }
                }
            })
            .catch(e => e);
    }
    async editGroup(data) {
        this.tableLoading = true;
        try {
            const res = await api.rgApi.updateDxGroupListener({
                ...data,
                settingStatus: data.settingStatus === 1 ? 0 : 1
            });
            const { code } = res;
            if (code === 200) {
                this.tableLoading = false;
                this.getDxGroupList();
                this.$mtd.message.success(data.settingStatus === 1 ? '停用成功！' : '启用成功！');
            }
        } catch (error) {
            this.tableLoading = false;
            console.log(error);
        }
    }
    get operations() {
        return [
            {
                label: scope => {
                    return scope.row.settingStatus === 1 ? '停用' : '启用';
                },
                action: 'control',
                click: (action: string, scope: any) => {
                    this.editGroup(scope.row);
                }
            },
            {
                label: '编辑',
                action: 'edit',
                click: (action: string, scope: any) => {
                    this.data = { ...scope.row, minute: scope.row.features.multiPre };
                    this.showModal = true;
                }
            },
            {
                label: '删除',
                action: 'delete',
                click: (action: string, scope: any) => {
                    this.deleteGroup(scope.row.id);
                }
            }
        ];
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
